import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Convenio, FuncaoService, Login } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { tsXLXS } from 'ts-xlsx-export';
import { LiquidacaoService } from '../../../contabil/liquidacao/service/liquidacao.service';
import { EmpenhoRestoService, LiquidacaoRestoService } from 'contabil-lib';
import { EmpenhoService } from 'administrativo-lib';

@Component({
  selector: 'lib-convenio-liquidacao',
  templateUrl: './convenio-liquidacao.component.html',
})
export class ConvenioLiquidacaoComponent implements OnInit, OnChanges, OnDestroy {

  protected unsubscribe: Subject<void> = new Subject();

  public listaLiqs: Array<any> = [];
  public liquidacoes: any;
  public liquidacoesResto: any;

  @Input() convenio: Convenio;
  @Input() login: Login;

  public paginaCorrente: number = 1;
  public paginaTotal: number;
  public limite: number = 20;
  public liquidacoesVisualizacao = []

  constructor(
    protected confirmationService: ConfirmationService,
    protected funcaoService: FuncaoService,
    protected liquidacaoService: LiquidacaoService,
    protected liquidacaoRestoService: LiquidacaoRestoService,
    protected empenhoRestoService: EmpenhoRestoService,
    protected empenhoService: EmpenhoService,
  ) { }

  async ngOnInit() {
    await this.buscarLiquidacoes();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  async ngOnChanges(changes: SimpleChanges) {
  }

  public exportarXLSX() {
    const listaItens = new Array();
    for (const item of this.listaLiqs) {
      const entity = {
        exercicio: item.empenho.exercicio.ano,
        empenho: item.empenho.numero,
        parcela: item.parcela > 0 ? item.parcela : '',
        data_liquidacao: this.funcaoService.converteDataBR(item.data_liquidacao),
        vencimento: this.funcaoService.converteDataBR(item.data_vencimento),
        documento: item.documento,
        valor_liquidado: item.valor_liquidado
      };
      listaItens.push(entity);
    }
    tsXLXS().exportAsExcelFile(listaItens).saveAsExcelFile(`liquidações - ${this.convenio.numero} ${this.convenio.ano}`);
  }

  public async proximaPagina() {
    if (this.paginaCorrente < this.paginaTotal) {
      this.paginaCorrente++;
      await this.buscarLiquidacoes();
      window.scrollTo(0, 0);
    }
  }

  public async paginaAnterior() {
    this.paginaCorrente = this.paginaCorrente === 1 ? 1 : this.paginaCorrente - 1;
    await this.buscarLiquidacoes();
    window.scrollTo(0, 0);
  }

  public async paginaDigitada(pagina: number) {
    this.paginaCorrente = pagina >= this.paginaTotal ? this.paginaTotal : pagina;
    await this.buscarLiquidacoes();
    window.scrollTo(0, 0);
  }

  public async mudarLimite(limite: number) {
    this.limite = limite;
    this.paginaDigitada(1);
    await this.buscarLiquidacoes();
  }

  public preencherLiqVisualizacao() {
    const inicio = (this.paginaCorrente - 1) * this.limite;
    const fim = inicio + this.limite;
    this.liquidacoesVisualizacao = this.listaLiqs.slice(inicio, fim);
  }

  public async buscarLiquidacoes(pagina: number = this.paginaCorrente) {

    this.liquidacoes = await this.liquidacaoService.filtrar(pagina, this.limite, { 'empenho.convenio.id': this.convenio.id, ignoreCondObrig: true, relations: 'empenho.exercicio,pagamentos.conta_recurso.recurso,pagamentos.conta.banco,pagamentos.conta_recurso.aplicacao,pagamentos.exercicio' }).toPromise();

    this.liquidacoesResto = await this.liquidacaoRestoService.filtrar(pagina, this.limite, { 'empenho.convenio.id': this.convenio.id, ignoreCondObrig: true, relations: 'pagamentos,empenho.exercicio' }).toPromise();

    for (const item of this.liquidacoesResto.content) {
      this.listaLiqs.push(item);
    }

    for (const item of this.liquidacoes.content) {
      this.listaLiqs.push(item);
    }

    this.paginaTotal = +this.liquidacoesResto.totalPages + +this.liquidacoes.totalPages;
    this.preencherLiqVisualizacao();
  }

}
